import * as React from 'react';

type Props = {
  classificationKey:
  | 'connect'
  | 'diagnostic'
  | 'sentence'
  | 'lessons'
  | 'passage'
  | 'evidence'
  | string;
};

const MAP: Record<
  string,
  { path: string; alt: string }
> = {
  connect: {
    path: '/images/icons/description-connect.svg',
    alt: 'Target representing Quill Connect',
  },
  diagnostic: {
    path: '/images/icons/description-diagnostic.svg',
    alt: 'Magnifying glass representing Quill Diagnostic',
  },
  sentence: {
    path: '/images/icons/description-grammar.svg',
    alt: 'Puzzle piece representing Quill Grammar',
  },
  lessons: {
    path: '/images/icons/description-lessons.svg',
    alt: 'Apple representing Quill Lessons',
  },
  passage: {
    path: '/images/icons/description-proofreader.svg',
    alt: 'Flag representing Quill Proofreader',
  },
  evidence: {
    path: '/images/icons/description-comprehension.svg',
    alt: 'Book representing Quill Reading for Evidence',
  },
};

export const ImageTagForClassification: React.FC<Props> = ({ classificationKey }) => {
  const match = MAP[classificationKey];
  const cdn = (window as any)?.postbuildEnv?.CDN_URL ?? '';
  const src = match ? `${cdn}${match.path}` : undefined;
  const alt = match ? match.alt : '';

  return <img alt={alt} src={src} />;
};

export default ImageTagForClassification;
